import axios, {
  type AxiosError,
  type AxiosHeaders,
  type AxiosRequestConfig
} from "axios";
import store from "./store";
import { UserApiData } from "./modules/security/models/user-model";
import { useUser } from "@/composables/apiModels/useUser";
import type {
  ResponseConfig as ResponseConfigType,
  RequestConfig as RequestConfigType,
  ResponseErrorConfig as ResponseErrorConfigType
} from "@kubb/plugin-client/clients/axios";
import { recursivelyHydrateDates } from "./recursivelyHydrateDates";

declare const AXIOS_BASE: string;
declare const AXIOS_HEADERS: string;

export type RequestConfigExt = {
  controller?: AbortController;
};

/**
 * Subset of AxiosRequestConfig
 */
export type RequestConfig<TData = unknown> = RequestConfigType<TData> & RequestConfigExt;
export type ResponseErrorConfig<TError = unknown> = ResponseErrorConfigType<TError>;

/**
 * Subset of AxiosResponse
 */
export type ResponseConfig<TData = unknown> = ResponseConfigType<TData>;

export const axiosInstance = axios.create({
  baseURL: typeof AXIOS_BASE !== "undefined" ? AXIOS_BASE : undefined,
  headers:
    typeof AXIOS_HEADERS !== "undefined" ? (JSON.parse(AXIOS_HEADERS) as AxiosHeaders) : undefined
});
// Add response interceptor
axiosInstance.interceptors.response.use((response) => {
  recursivelyHydrateDates(response.data);
  return response;
});

export const axiosClient = async <TData, TError = unknown, TVariables = unknown>(
  config: RequestConfig<TVariables>
): Promise<ResponseConfig<TData>> => {
  config.controller = new AbortController();
  config.signal = config.controller.signal;
  const user: UserApiData = store.getters["security/getUser"]();
  const { isEmployee } = useUser();
  if (user && isEmployee(user) && config.url) {
    //  config.url = config.url.replace(/(api\/)/, "$1personale/");
  }

  const promise = axiosInstance
    .request<TData, ResponseConfig<TData>>(config as AxiosRequestConfig)
    .catch((e: AxiosError<TError>) => {
      throw e;
    });

  return promise;
};

export default axiosClient;
